<script>
  import CityCombo from '../CityCombo.svelte'
  import ValueCombo from '../ValueCombo.svelte'
  import FiltersInput from './FiltersInput.svelte'
  import FiltersSelectable from './FiltersSelectable.svelte'
  import { cities, countries, selectedGroups } from '../../store'
  import { onMount } from 'svelte'

  export let filter = {}
  export let fk = ''
  export let filters = {}
  export let origin = []

  let dates = {}

  onMount(() => {
    // console.log('[DEBUG] f:', fk)
  })

  function selectableOnChangeHandler (group) {
    // console.log('[DEBUG] selectableOnChange', fk, group)
    // to avoid click animation lagging
    setTimeout(() => {
      console.log('[DEBUG] new ' + fk + ' value', group)
      filter.value = group
      $selectedGroups[fk] = [...group]
    }, 100)
  }
</script>

{#if filter.city}
  <CityCombo label={filter.label}
             top={'3.4em'}
             items={$cities}
             bind:cityProp={filter.value}
             bind:countryProp={filters[filter.country].value}
  />

{:else if filter.country}
  <ValueCombo label={filter.label}
              top={'3.4em'}
              items={$countries}
              bind:valueProp={filter.value}
  />
{:else if filter.select}
  <div class="mb-4 px-1">
    <FiltersSelectable
      fk={fk}
      label={filter.label}
      group={$selectedGroups[fk] || []}
      data={origin}
      on:change={({detail}) => { selectableOnChangeHandler(detail) }}
    />
  </div>


{:else}

  <FiltersInput bind:filter={filter} {fk} bind:dates={dates} />

{/if}